import request from '@/utils/request'

// 获取个人信息
export function fetchUserInfo(query) {
  return request({
    url: '/api/v1/userinfo',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 编辑个人信息
export function postUserInfo(data) {
  return request({
    url: '/api/v1/usersimpleinfo',
    baseURL: 'other',
    method: 'put',
    data
  })
}

// 编辑用户注册
export function EditUser(data) {
  return request({
    url: `/api/v1/userinfo`,
    baseURL: 'other',
    // url: '/api/v1/station/userinfo',
    method: 'put',
    data
  })
}

export function getUserNonbsSet(query) {
  return request({
    url: '/api/v1/nonbs/set',
    method: 'get',
    params: query
  })
}

export function setUserNonbs(query) {
  return request({
    url: '/api/v1/nonbs/set',
    method: 'post',
    data: query
  })
}

// 微信绑定手机号发送验证码
export function bindUserPhoneSendCode(query) {
  return request({
    url: '/api/v1/bind/sendcode',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 微信绑定手机号
export function bindUserPhoneVerify(phone, code, query) {
  var url = '/api/v2/wechat/bind/phone/token?phone=' + phone
  if (code !== '') {
    url += '&code=' + code
  }
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: url,
    baseURL: 'other',
    method: 'post',
    data: query
  })
}

/**
 * Line绑定手机号
 * @param phone
 * @param code
 * @param query
 */
export function bindUserPhoneVerifyLine(query) {
  return request({
    url: '/api/v1/accountthird/phone/login',
    baseURL: 'other',
    method: 'post',
    data: query
  })
}

// 更换手机号发送验证码
export function replaceUserPhoneSendCode(query) {
  return request({
    url: '/api/v1/replace/sendcode',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 更换手机号
export function replaceUserPhoneVerify(query) {
  return request({
    url: '/api/v1/replace/verifyphone',
    baseURL: 'other',
    method: 'put',
    params: query
  })
}
